import React from "react";
import {View, Svg, Line, G, Rect, Path, StyleSheet} from "@react-pdf/renderer";
import MarkDamagesOnTrailerPrintout from "../markDamagesOnTrailerPrintout";
import {SideType} from "../../../../../models/transport";
import {DamageLocation, EquipmentType} from "../../../../../models/tcr";
import {OrderFilesUtils} from "../../../../../../helpers/orderFilesUtils";

const tcrReportStyles = StyleSheet.create(OrderFilesUtils.tcrReportStyles);

export default function Front(): React.ReactElement {
    return (
        <View style={tcrReportStyles.centerPicture}>
            <Svg
                viewBox="0 0 276 300"
                style={tcrReportStyles.pictureSize}
                id="trailer-front"
            >
                <Rect
                    x="1"
                    y="1"
                    width="274"
                    height="200.41"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                />
                <Rect
                    x="248.85193"
                    y="210.40306"
                    width="24.887747"
                    height="88.121567"
                    rx="12.443861"
                    ry="12.443861"
                    fill="#ffffff"
                    stroke="#8e8e8e"
                    strokeWidth="2"
                />
                <Rect
                    x="88.1579"
                    y="201.795"
                    width="19.7895"
                    height="91.9759"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                />
                <Rect
                    x="164.421"
                    y="201.795"
                    width="19.7895"
                    height="91.9759"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                />
                <Path
                    d="M154.5 202L108.5 238.5"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                />
                <Line
                    x1="0"
                    y1="-1"
                    x2="56.6176"
                    y2="-1"
                    transform="matrix(0.769706 0.638398 -0.641969 0.766731 119.842 202.41)"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                />
                <Rect
                    x="1.8768388"
                    y="210.04718"
                    width="24.887747"
                    height="88.121567"
                    rx="12.443861"
                    ry="12.443861"
                    fill="#ffffff"
                    stroke="#8e8e8e"
                    strokeWidth="2"
                />
                <Rect
                    opacity={1}
                    fill="#ffffff"
                    fillOpacity={1}
                    fillRule="evenodd"
                    stroke="#8E8E8E"
                    strokeWidth="2.02109"
                    strokeLineCap="butt"
                    strokeDasharray="none"
                    strokeOpacity={1}
                    width="136.71188"
                    height="99.654442"
                    x="1.0276414"
                    y="1.16874"
                    key="TARPAULIN__LEFT_TOP"
                />
                <Rect
                    opacity={1}
                    fill="#ffffff"
                    fillOpacity={1}
                    fillRule="evenodd"
                    stroke="#8E8E8E"
                    strokeWidth="2.02735"
                    strokeLineCap="butt"
                    strokeDasharray="none"
                    strokeOpacity={1}
                    width="136.70558"
                    height="100.27728"
                    x="1.1269542"
                    y="100.82896"
                    key="TARPAULIN__LEFT_BOTTOM"
                />
                <Rect
                    opacity={1}
                    fill="#ffffff"
                    fillOpacity={1}
                    fillRule="evenodd"
                    stroke="#8E8E8E"
                    strokeWidth="2.02201"
                    strokeLineCap="butt"
                    strokeDasharray="none"
                    strokeOpacity={1}
                    width="136.8367"
                    height="99.653984"
                    x="137.6683"
                    y="1.0433799"
                    key="TARPAULIN__RIGHT_TOP"
                />
                <Rect
                    opacity={1}
                    fill="#ffffff"
                    fillOpacity={1}
                    fillRule="evenodd"
                    stroke="#8E8E8E"
                    strokeWidth="2.02827"
                    strokeLineCap="butt"
                    strokeDasharray="none"
                    strokeOpacity={1}
                    width="136.83038"
                    height="100.27682"
                    x="137.7677"
                    y="100.70315"
                    key="TARPAULIN__RIGHT_BOTTOM"
                />
                <Rect
                    x="99"
                    y="1"
                    width="78"
                    height="78"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    key="AGGREGATE"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.FRONT}
                        equipmentType={EquipmentType.AGGREGATE}
                        damageLocation={null}

                    />
                </Rect>
                <G
                    transform="translate(-96.377902,18.118039)"
                    key="TARPAULIN__LEFT_TOP.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.FRONT}
                        equipmentType={EquipmentType.TARPAULIN}
                        damageLocation={DamageLocation.LEFT_TOP}
                    />
                </G>
                <G
                    transform="translate(94.868066,21.389352)"
                    key="TARPAULIN__RIGHT_TOP.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.FRONT}
                        equipmentType={EquipmentType.TARPAULIN}
                        damageLocation={DamageLocation.RIGHT_TOP}
                    />
                </G>
                <G
                    transform="translate(63.916416,114.49594)"
                    key="TARPAULIN__RIGHT_BOTTOM.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.FRONT}
                        equipmentType={EquipmentType.TARPAULIN}
                        damageLocation={DamageLocation.RIGHT_BOTTOM}
                    />
                </G>
                <G
                    transform="translate(-77.253305,116.00578)"
                    key="TARPAULIN__LEFT_BOTTOM.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.FRONT}
                        equipmentType={EquipmentType.TARPAULIN}
                        damageLocation={DamageLocation.LEFT_BOTTOM}
                    />
                </G>
            </Svg>
        </View>
    );
}